import React, { useState } from 'react';
import '../styles/AIDrillInput.css';

const AIDrillInput = ({ onGenerate, isGenerating, selectedLanguage }) => {
  const [keyword, setKeyword] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (keyword.trim() && !isGenerating && onGenerate) {
      onGenerate(keyword.trim());
    }
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    if (!isExpanded) {
      setKeyword('');
    }
  };

  const getLanguageText = () => {
    return {
      title: 'AI Sentence Expansion',
      placeholder: 'Enter a word...',
      button: 'Start AI Expansion',
      buttonGenerating: 'AI is expanding...'
    };
  };

  const langText = getLanguageText();

  return (
    <div className="ai-drill-input">
      <button 
        className={`toggle-button ${isExpanded ? 'expanded' : ''}`}
        onClick={handleToggle}
        disabled={isGenerating}
      >
        <span className="button-icon">🤖</span>
        <span className="button-text">{langText.title}</span>
        <span className="button-arrow">{isExpanded ? '▲' : '▼'}</span>
      </button>

      {isExpanded && (
        <div className="input-panel">
          <form onSubmit={handleSubmit} className="input-form">
            <div className="input-group">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder={langText.placeholder}
                className="keyword-input"
                disabled={isGenerating}
                maxLength={20}
              />
              <button
                type="submit"
                className={`generate-button ${isGenerating ? 'generating' : ''}`}
                disabled={!keyword.trim() || isGenerating}
              >
                {isGenerating ? (
                  <>
                    <span className="spinner"></span>
                    {langText.buttonGenerating}
                  </>
                ) : (
                  <>
                    <span className="button-icon">✨</span>
                    {langText.button}
                  </>
                )}
              </button>
            </div>
          </form>
          
          <div className="input-hint">
            <span className="hint-icon">💡</span>
            <span className="hint-text">
              Enter a word and AI will generate a 15-step sentence expansion exercise for you
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIDrillInput;
